/* Luchos Club page helpers: UTM capture, smooth scroll to the form, CTA tracking, sticky mobile CTA, gallery arrows. */
(() => {
  if (window.__lcClub) return;
  window.__lcClub = true;

  const track = (name, data = {}) => {
    try { window.Shopify?.analytics?.publish?.(name, data); } catch (e) {}
  };

  // Keep paid-traffic parameters for the whole session so the multi-step form can send them.
  try {
    const params = new URLSearchParams(location.search);
    const keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id', 'fbclid', 'gclid', 'ttclid'];
    const found = {};
    keys.forEach((k) => { if (params.get(k)) found[k] = params.get(k).slice(0, 200); });
    if (Object.keys(found).length) {
      found.landing_page = location.pathname;
      sessionStorage.setItem('lc_utm', JSON.stringify(found));
    }
  } catch (e) {}

  track('lc_page_view', { page: location.pathname });

  const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const scrollToEl = (el, smooth = true) => {
    const header = document.querySelector('#header-group');
    const offset = (header ? header.getBoundingClientRect().bottom : 0) + 12;
    let sc = el.parentElement;
    while (sc && sc !== document.body && !(sc.scrollHeight > sc.clientHeight && /(auto|scroll)/.test(getComputedStyle(sc).overflowY))) sc = sc.parentElement;
    const behavior = smooth && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'auto';
    if (!sc || sc === document.body) return window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - offset, behavior });
    sc.scrollTo({ top: el.getBoundingClientRect().top - sc.getBoundingClientRect().top + sc.scrollTop - offset, behavior });
  };

  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-lc-cta]');
    if (!a) return;
    track('lc_cta_click', { location: a.dataset.lcCta });
    const href = a.getAttribute('href') || '';
    if (href.startsWith('#')) {
      const target = document.getElementById(href.slice(1));
      if (!target) return;
      e.preventDefault();
      scrollToEl(target);
      history.replaceState(null, '', href);
      setTimeout(() => target.querySelector('input, select, textarea')?.focus({ preventScroll: true }), reduced() ? 0 : 600);
    }
  });

  const initSticky = () => {
    const bar = document.querySelector('[data-lc-sticky]');
    const heroCta = document.querySelector('[data-lc-hero-cta]');
    if (!bar || !heroCta || !('IntersectionObserver' in window)) return;
    const form = document.getElementById('apply');
    const footer = document.querySelector('.lc-footer');
    const state = { hero: true, form: false, footer: false };
    const update = () => bar.classList.toggle('is-visible', !state.hero && !state.form && !state.footer);
    const watch = (el, key) => el && new IntersectionObserver(([en]) => { state[key] = en.isIntersecting; update(); }, { threshold: 0 }).observe(el);
    watch(heroCta, 'hero');
    watch(form, 'form');
    watch(footer, 'footer');
  };

  const initGalleries = () => {
    document.querySelectorAll('[data-lc-gallery]').forEach((g) => {
      if (g.dataset.ready) return;
      g.dataset.ready = '1';
      const track = g.querySelector('[data-lc-track]');
      const prev = g.querySelector('[data-lc-prev]');
      const next = g.querySelector('[data-lc-next]');
      if (!track || !prev || !next) return;
      const step = () => (track.firstElementChild?.getBoundingClientRect().width || 200) + 10;
      const sync = () => {
        prev.disabled = track.scrollLeft < 4;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      };
      prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  };

  const boot = () => { initSticky(); initGalleries(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', initGalleries);
})();
